import { render, staticRenderFns } from "./PendingTransactionHistoryHeader.vue?vue&type=template&id=29d20128&"
import script from "./PendingTransactionHistoryHeader.vue?vue&type=script&lang=js&"
export * from "./PendingTransactionHistoryHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports